const waitForWishlistRendering = () => {
  // Select the node that will be observed for mutations
  const targetNode = document.getElementById('main');

  // Options for the observer (which mutations to observe)
  const config = { attributes: true, childList: true, subtree: true };

  // Callback function to execute when mutations are observed
  const callback = function(mutationList, observer) {
    // Use traditional 'for loops' for IE 11
    for (const mutation of mutationList) {
      if (mutation.type === 'childList') {
        let wishlistPageEls = document.querySelectorAll('.ssw-product-link');
        if (wishlistPageEls.length) {
          initWishlistItems();
          observer.disconnect();
        }
      }
    }
  };

  // Create an observer instance linked to the callback function
  const observer = new MutationObserver(callback);

  // Start observing the target node for configured mutations
  observer.observe(targetNode, config);
};

const initWishlistItems = () => {
  const items = document.querySelectorAll('.ssw-product-link');
  if (items) {
    items.forEach(item => {
      let cloneItem = item.cloneNode(true);
      
      item.parentNode.appendChild(cloneItem);
      item.remove();

      cloneItem.classList.add('processed');
      cloneItem.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        window.location.href = e.target.href;
      });
    })
  }
}

window.addEventListener('load', () => {
  waitForWishlistRendering();
});